(function () {
  var STYLE_ID = 'dave-shipping-urgency-preview-css';
  var ROOT_SELECTOR = '.trustblox-1-timer-wrap, .trustblox-timer, [class*="trustblox-1-timer"]';

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.dave-shipping-urgency{font-family:Inter,sans-serif!important;color:#151515!important;text-align:center!important;background:#fff!important;box-sizing:border-box!important;width:100%!important;}',
      '.dave-shipping-urgency__title{font-family:Inter,sans-serif!important;font-size:20px!important;font-weight:700!important;margin:0 0 14px!important;color:#151515!important;line-height:1.4!important;}',
      '.dave-shipping-urgency__main{font-family:Inter,sans-serif!important;font-size:18px!important;font-weight:400!important;margin:0!important;color:#151515!important;line-height:1.4!important;}',
      '.dave-shipping-urgency__time{font-family:Inter,sans-serif!important;color:#108914!important;font-size:18px!important;font-weight:700!important;white-space:nowrap!important;}',
      '.productgrid--masthead-right .free-shipping-box{border:1px solid #eaebed!important;padding:16px 10px!important;margin-bottom:35px!important;}',
      '.productgrid--masthead-right .dave-shipping-urgency{max-width:235px!important;margin:0 auto!important;}',
      '@media (max-width:480px){.dave-shipping-urgency__title{font-size:18px!important}.dave-shipping-urgency__main,.dave-shipping-urgency__time{font-size:16px!important;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function textNumber(root, names, label) {
    for (var i = 0; i < names.length; i++) {
      var matches = root.querySelectorAll('[class*="' + names[i] + '"]');
      for (var j = 0; j < matches.length; j++) {
        var txt = (matches[j].textContent || '').replace(/\D+/g, '');
        if (txt) return parseInt(txt, 10) || 0;
      }
    }
    var all = (root.textContent || '').replace(/\s+/g, ' ');
    var re = new RegExp('(\\d+)\\s*' + label, 'i');
    var found = all.match(re);
    return found ? (parseInt(found[1], 10) || 0) : 0;
  }

  function getRemainingSeconds(root) {
    var days = textNumber(root, ['days', 'day'], 'days?');
    var hours = textNumber(root, ['hours', 'hour'], 'hours?');
    var minutes = textNumber(root, ['minutes', 'minute', 'mins', 'min'], 'minutes?|mins?');
    var seconds = textNumber(root, ['seconds', 'second', 'secs', 'sec'], 'seconds?|secs?');
    var total = (days * 86400) + (hours * 3600) + (minutes * 60) + seconds;
    return total > 0 ? total : null;
  }

  function formatTime(totalSeconds) {
    totalSeconds = Math.max(totalSeconds, 1);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.ceil((totalSeconds % 3600) / 60);
    if (minutes === 60) {
      hours += 1;
      minutes = 0;
    }
    var parts = [];
    if (hours > 0) parts.push(hours + ' ' + (hours === 1 ? 'Hour' : 'Hours'));
    if (minutes > 0 || parts.length === 0) parts.push(minutes + ' ' + (minutes === 1 ? 'Minute' : 'Minutes'));
    return parts.join(' ');
  }

  function apply(root) {
    if (!root || root.dataset.daveShippingUrgency === 'done') return;
    var remaining = getRemainingSeconds(root);
    if (!remaining) return;

    ensureStyle();
    root.dataset.daveShippingUrgency = 'done';
    var expiresAt = Date.now() + (remaining * 1000);

    root.innerHTML = '<div class="dave-shipping-urgency" aria-live="polite">' +
      '<p class="dave-shipping-urgency__title">Free Delivery</p>' +
      '<p class="dave-shipping-urgency__main">Order within <span class="dave-shipping-urgency__time"></span> to ship today!</p>' +
      '</div>';

    var timeEl = root.querySelector('.dave-shipping-urgency__time');
    function tick() {
      var left = Math.max(0, Math.round((expiresAt - Date.now()) / 1000));
      if (timeEl) timeEl.textContent = formatTime(left);
    }
    tick();
    setInterval(tick, 60000);
  }

  function scan() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) apply(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
